import * as Factory from 'factory.ts'
import faker from 'faker'

import { APApprovalChainTypes } from '@webapp/models/enums'
import { SimpleUserMock } from './user.factory'
import {
  type ApprovalChain,
  type ApprovalChainApprover,
  type ApprovalChainLevel,
} from '../../models'

export const ApprovalChainApproverMock =
  Factory.Sync.makeFactory<ApprovalChainApprover>({
    id: Factory.each(() => faker.random.number()),
    amount_limit: '100',
    approval_level: 0,
    bill_amount_limit: '100',
    item_variance_amount_limit: '0',
    item_variance_percentage_limit: '0',
    user: Factory.each(() => SimpleUserMock.build()),
  })

export const ApprovalChainLevelMock =
  Factory.Sync.makeFactory<ApprovalChainLevel>({
    id: Factory.each(() => faker.random.number()),
    level: 0,
    approvers: ApprovalChainApproverMock.buildList(1),
  })

export const ApprovalChainMock = Factory.Sync.makeFactory<ApprovalChain>({
  id: Factory.each(() => faker.random.number()),
  approval_levels: ApprovalChainLevelMock.buildList(1),
  name: Factory.each(
    () => `${faker.company.companyName()} ${faker.company.companySuffix()}`
  ),
  type: APApprovalChainTypes.BILL_APPROVAL,
})
